import { FC } from 'react'
import { MenuItem, TextField } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import { authStore } from '@/store/authStore'
import { canalStore } from '@/store/canalStore'
import { CANAIS_COMERCIAIS, CANAL_LABEL, CanalComercial } from '@/types/statusReserva'

/**
 * Seletor global de canal do back-office — "Origem: Todos os canais ▾" (Onda 1 / A02).
 *
 * Lista FECHADA (decisão 6.7): DIRECT / CONSULTANT / STRUCTURED_CONSULTANT_CHANNEL /
 * STRUCTURED_CONSULTANT_WHITE_LABEL, com os rótulos em português de
 * `types/statusReserva.ts`. Visível só para ADMIN/GERENTE; guarda o canal no
 * `canalStore` e espelha em `?canal=` na URL (o parâmetro que o resumo do
 * Dashboard aceita via `dashboardService.getResumo`).
 *
 * NÃO montado no TopBar nesta rodada — o TopBar é do A01; o coordenador integra
 * no merge. Exportado e testado aqui.
 */
export const SeletorCanalGlobal: FC = () => {
  const usuario = authStore((s) => s.usuario)
  const canal = canalStore((s) => s.canal)
  const setCanal = canalStore((s) => s.setCanal)
  const [searchParams, setSearchParams] = useSearchParams()

  const visivel = !!usuario?.permissoes?.some((p) =>
    ['ADMIN', 'GERENTE'].includes(p.toUpperCase()))
  if (!visivel) return null

  const aoMudar = (valor: string) => {
    const novo = (valor || '') as '' | CanalComercial
    setCanal(novo)
    const proximos = new URLSearchParams(searchParams)
    if (novo) {
      proximos.set('canal', novo)
    } else {
      proximos.delete('canal')
    }
    setSearchParams(proximos, { replace: true })
  }

  return (
    <TextField
      select
      size="small"
      label="Origem"
      value={canal}
      onChange={(e) => aoMudar(e.target.value)}
      sx={{ minWidth: 240 }}
      // displayEmpty: com valor '' o Select do MUI mostraria um espaço em branco;
      // o Figma pede "Origem: Todos os canais ▾" já no estado padrão.
      SelectProps={{ displayEmpty: true }}
      InputLabelProps={{ shrink: true }}
      inputProps={{ 'aria-label': 'Origem: canal comercial' }}
    >
      <MenuItem value="">Todos os canais</MenuItem>
      {CANAIS_COMERCIAIS.map((c) => (
        <MenuItem key={c} value={c}>
          {CANAL_LABEL[c]}
        </MenuItem>
      ))}
    </TextField>
  )
}
